import { render, staticRenderFns } from "./RelatorioVeiculoPrintModal.vue?vue&type=template&id=2fe53ad6&scoped=true"
import script from "./RelatorioVeiculoPrintModal.vue?vue&type=script&lang=js"
export * from "./RelatorioVeiculoPrintModal.vue?vue&type=script&lang=js"
import style0 from "./RelatorioVeiculoPrintModal.vue?vue&type=style&index=0&id=2fe53ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe53ad6",
  null
  
)

export default component.exports